document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".anim_card").forEach(card => {
        const wrapper = card.querySelector(".IconAnim");
        const img = wrapper.querySelector("img");

        const init = () => {
            const imgWidth = img.offsetWidth + 32;
            const containerWidth = wrapper.offsetWidth;

            const needed = Math.ceil(containerWidth / imgWidth) + 2;

            let loadedCount = 0;
            const total = needed;

            const onImgLoaded = () => {
                loadedCount++;
                if (loadedCount === total) {
                    wrapper.classList.add("ready");
                }
            };

            // pierwsza
            if (img.complete) onImgLoaded();
            else img.onload = onImgLoaded;

            // klony
            for (let i = 1; i < needed; i++) {
                const clone = img.cloneNode(true);
                clone.onload = onImgLoaded;
                wrapper.appendChild(clone);
            }

            // --- PAUSE ON HOVER ---
            card.addEventListener("mouseenter", () => {
                wrapper.querySelectorAll("img").forEach(el => {
                    el.style.animationPlayState = "paused";
                });
            });

            card.addEventListener("mouseleave", () => {
                wrapper.querySelectorAll("img").forEach(el => {
                    el.style.animationPlayState = "running";
                });
            });
        };

        if (img.complete) init();
        else img.onload = init;
    });
});
